import project01 from '../img/projects/pizzaHome.jpg';
import project02 from '../img/projects/project02.jpg';
import project03 from '../img/projects/project03.jpg';
import project04 from '../img/projects/project04.jpg';

export const projects = [
  {
    id: 0,
    title: 'Pizza Home',
    skills: 'React, ReactHooks, Redux-toolkit, pagination, axios, API',
    image: project01,
    gitHubLink: 'https://github.com/AntonKrivelo/PizzaRemastered.git',
    projectSite: 'http://pzhome.site/',
  },
  {
    id: 1,
    title: 'React Sneakers',
    skills: 'React, ReactHooks, pagination, axios, API',
    image: project02,
    gitHubLink: 'https://github.com/AntonKrivelo/ReactSneakers',
    projectSite: null,
  },
  {
    id: 2,
    title: 'Shop Furniture Project',
    skills: 'React, ReactHooks, ReactHooksForm, mockAPI, Redux-toolkit, pagination, searchFilter',
    image: project03,
    gitHubLink: 'https://github.com/AntonKrivelo/shopFurniture',
    projectSite: 'https://antonkrivelo.github.io/shopFurniture/',
  },
  {
    id: 3,
    title: 'Table Test',
    skills: 'React, ReactHooks, searchFilter',
    image: project04,
    gitHubLink: 'https://github.com/AntonKrivelo/TableTest',
    projectSite: 'https://antonkrivelo.github.io/TableTest',
  },
];
